<!-- table operation  -->
<div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>

<mat-menu #menu="matMenu" xPosition="before">
  <!-- *edit btn -->
  <div
    *ngIf="input_isShowEditBtn"
    app-menu-btn
    icon="edit"
    [class.border-bottom]="input_isShowDeleteBtn"
    (click)="emitEdit()"
  ></div>

  <!-- *detail btn -->
  <div
    *ngIf="input_isShowDetailsBtn"
    app-menu-btn
    icon="details"
    color="gray"
    (click)="emitDetails()"
  ></div>

  <!-- *delete btn -->
  <div
    *ngIf="input_isShowDeleteBtn"
    app-menu-btn
    icon="delete"
    (click)="emitDelete()"
  ></div>

  <div select="customBtn"></div>
</mat-menu>
